import { FavoritePrepaidCardRow } from '@models/prepaidCard';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// TODO 제거
export interface PrepaidCard {
    name: string;
    amount: number;
    img: string;
}

export const prepaidCardsAtom = atomWithStorage<PrepaidCard[]>('prepaidCards', []);

export const currentCardAtom = atom<FavoritePrepaidCardRow|undefined>();

export const amountAtom = atom<number>(0);
